import * as React from "react";
import { renderOutrightMarkets } from "../LiveOutright";
import * as RenderMethods from "./RenderMethods"
import { EventCardProps } from "../EventCard";

export class MiniOutright extends React.Component<EventCardProps, {}> {
    buttonsHolderClass: string
    componentPrefix: string

    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);

        this.componentPrefix = "mini-outright";
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder`;
    }

    renderOutrightDetails = RenderMethods.renderMiniOutrightDetails;
    renderMarkets = renderOutrightMarkets;

    render() {
        const isSelected = this.props.event.isSelected ? `rj-ev-list__${this.componentPrefix}--selected` : "";

        return (
            <div className={`rj-ev-list__${this.componentPrefix} ${isSelected}`} data-uat={`div-ev-list-${this.componentPrefix}`}>
                {this.renderOutrightDetails(this.props.event, this.props.handlers, this.props.isFavoritesEnabled, this.componentPrefix)}
                {this.props.showOddBtns && this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix)}
            </div>
        )
    }
}